/* eslint-disable no-console */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const logData = (...data: any): void => console.log(...data);
